import { Component } from '@angular/core';
import { PaypalService } from './services/paypal.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(
    public paypalService: PaypalService
  ){
    this.paypalService.addPaypalScript();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts